const Title = ({ title, children, className = '' }) => {
  return (
    <div className={`card-title justify-between ${className}`}>
      { title && (
        <h2 className="text-md md:text-xl font-semibold mb-2">{title}</h2>
      )}
      {children}
    </div>
  )
}

const Body = ({ children, animateUpdate = false, 
  columns = 3, bgColor = 'gray-100', className = 'p-6 rounded-none'
}) => {
  let gridColsClass = "grid-cols-1 md:grid-cols-3 lg:grid-cols-3";
  
  if (columns === 1) {
    gridColsClass = "grid-cols-1";
  } else if (columns === 2) {
    gridColsClass = "grid-cols-1 md:grid-cols-2 lg:grid-cols-2";
  } else if (columns === 4) {
    gridColsClass = "grid-cols-1 md:grid-cols-2 lg:grid-cols-4";
  } else if (columns === 5) {
    gridColsClass = "grid-cols-1 md:grid-cols-3 lg:grid-cols-5";
  } else if (columns === 6) {
    gridColsClass = "grid-cols-1 md:grid-cols-3 lg:grid-cols-6";
  }

  let bgClass = "bg-gray-100"
  if(bgColor === 'white') {
    bgClass = "bg-white"
  }

  return (
    <div className={`card-body ${bgClass} ${className} transition-all duration-1000 ${animateUpdate ? 'skeleton' : ''}`}>
      <div className={`grid ${gridColsClass} gap-4`}>
        {children}
      </div>
    </div>
  )
}

const SectionPanel = ({ 
  title, 
  children, 
  animateUpdate = false, 
  columns = 3, 
  className = "" 
}) => (
  <div className={`card mb-8 ${className}`}>
    { title && <>
      <Title title={title} />
      <Body animateUpdate={animateUpdate} columns={columns}>
        {children}
      </Body>
    </>}
    { !title && children }
  </div>
)

export default Object.assign(SectionPanel, { Body, Title })